// CSS Modules - component class name prefix: ContentTeaserS__

<template>
  <figure :class="$style.container">
    <a v-if="isVideo" :class="[$style.mediaLink, $style.videoLink]" @click="isModalOpen = true">
      <i class="fab fa-youtube"></i>
      <img :src="image" :alt="linkTitle">
    </a>
    <a v-if="!isVideo" :class="$style.mediaLink" :href="primaryLink" :target="primaryLinkNewWindow ? '_blank' : '_self'">
      <img :src="image" :alt="linkTitle">
    </a>
    <figcaption>
      <a :class="$style.secondaryLink" :href="secondaryLink" :target="secondaryLinkNewWindow ? '_blank' : '_self'">{{ category }}</a>
      <a v-if="isVideo" :class="$style.primaryLink" @click="isModalOpen = true">{{ linkTitle }}</a>
      <a v-if="!isVideo" :class="$style.primaryLink" :href="primaryLink" :target="primaryLinkNewWindow ? '_blank' : '_self'">{{ linkTitle }}</a>
    </figcaption>
    <Modal v-if="isVideo" :isModalOpen="isModalOpen" :isVideo="isVideo" @closeModal="isModalOpen = false">
      <iframe v-if="isModalOpen" :src="primaryLink" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </Modal>
  </figure>
</template>

<script>
import Modal from "../Modal/Modal.vue";

export default {
  name: "ContentTeaserS",
  components: {
    Modal
  },
  props: {
    isVideo: {
      type: Boolean,
      default: false
    },
    primaryLink: {
      type: String,
      default: ""
    },
    primaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    secondaryLink: {
      type: String,
      default: ""
    },
    secondaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    category: {
      type: String,
      default: ""
    },
    linkTitle: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isModalOpen: false
    };
  }
};
</script>

<style module lang="scss">
@import "./ContentTeaserS.scss";
</style>
